'use client'

import { FC } from 'react'
import { List } from './styled';
import { BrokerRequestItem } from './BrokerRequestItem';
import { BrokerData } from '@/types';
import { CheckboxGreenIcon, WhatsAppIcon } from '@/components';
import { useGetBrokerRequests } from '@/queris';

type BrokerRequestListProps = {
  objectId: string;
  brokerData: BrokerData;
}

export const BrokerRequestList: FC<BrokerRequestListProps> = ({
  objectId, brokerData,
}) => {
  const { data } = useGetBrokerRequests(objectId)

  if (!data?.length) return null;

  return (
    <List>
      {/* Icons in item bug fix: */}
      <div style={{ display: 'none' }}>
        <WhatsAppIcon />
        <CheckboxGreenIcon />
      </div>
      {data?.map((item, i) => <BrokerRequestItem data={item} key={i} brokerData={brokerData} />)}
    </List>
  )
}
